import {BackupLimitations} from "./backup-limitations";

export class BackupLimitationsMapper {

  public static map(data: any): BackupLimitations {
    let backupLimitations: BackupLimitations = new BackupLimitations();

    backupLimitations.id = data._id; // TODO: data.id; if multiple jobs available
    backupLimitations.deleteCount = data.delete_count;
    backupLimitations.domainId = data.domain_id;
    backupLimitations.storage = data.storage;
    backupLimitations.maxStorage = data.max_storage;
    backupLimitations.updatedAt = data.updated_at ? new Date(data.updated_at) : null;
    backupLimitations.createdAt = data.created_at ? new Date(data.created_at) : null;
    backupLimitations.method = data.network && data.network.method ? data.network.method : null;
    return backupLimitations;
  }

}
